// extracted by css-extract-rspack-plugin
module.exports =  {"details":"ActivationCodeForm-vkMe__details","form":"ActivationCodeForm-m0jb__form"};